import { useSelector } from 'react-redux'
import { selectId as selectPaymentMethodId } from '../app/reducers/paymentMethod'
import { selectList } from '../app/reducers/methodsList'
import { useTranslation } from '../hooks/useTranslation'

export default function PaymentResultMethod(){
  const methodId = useSelector(selectPaymentMethodId);
  const methodsList = useSelector(selectList);
  const { t } = useTranslation();

  if(methodsList.length !== 1) return null;
  const method = methodsList.find((m) => m.id === methodId) || methodsList[0];
  if(!method) return null;

  const name = 'i18nKey' in method ? t(method.i18nKey) : method.name;

  return (
    <div className={"payment-result-method"}>
      <div className={"payment-result-method-left"}>
        {method.small_icon && <img className={"payment-result-method-icon"} src={method.small_icon} alt="" />}
        <span className={"payment-result-method-label"}>{t('payment.select_method')}</span>
      </div>
      <div className={"payment-result-method-right"}>{name}</div>
    </div>
  );
}
